// Logo exports for consistent branding throughout the app
export const LOGOS = {
  // Full logos
  BLUE_TRANSPARENT: "https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1752375791230-VIXEA%20TRANSPARENTE%20BLUE%2001.png",
  WHITE_TRANSPARENT: "https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1752375805882-VIXEA%20TRANSPARENTE%20WHITE%2001.png",
  
  // Favicons
  FAVICON_BLUE: "https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1752375796753-VIXEA%20FAVICON%20BLUE%20SIN%20FONDO%2001%20full.png",
  FAVICON_WHITE: "https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1752375801570-VIXEA%20FAVICON%20WHITE%20SIN%20FONDO%2001%20full.png",
  
  // Profile icon
  PROFILE_BLUE: "https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1752375836820-VIXEA%20PROFILE%20BLUE%2001%20full.png"
};

export default LOGOS;